import type { PartitionDraft, ZoneDraft } from "../project/model";

/**
 * Split a zone into cabinets of a standard width. What is left over goes to a filler at the
 * end when it is small (under 150 mm), otherwise to one narrower cabinet. Partitions an
 * appliance, sink or hob already holds keep their place; the cabinets fill the gaps around them.
 */
export function autoPartitions(zone: ZoneDraft, widthUm: number, idPrefix: string): PartitionDraft[] {
  const fixed = zone.partitions
    .filter((p) => p.purpose !== "cabinets" && p.purpose !== "filler")
    .sort((a, b) => a.offset - b.offset);
  const out: PartitionDraft[] = [];
  let seq = 0;
  const id = () => `${idPrefix}${++seq}`;
  const fill = (from: number, to: number) => {
    let x = from;
    const span = to - from;
    const count = Math.floor(span / widthUm);
    for (let i = 0; i < count; i++) {
      out.push({ id: id(), offset: x, width: widthUm, purpose: "cabinets" });
      x += widthUm;
    }
    const rest = to - x;
    if (rest <= 0) return;
    if (rest < 150_000) out.push({ id: id(), offset: x, width: rest, purpose: "filler", label: "Нөхөх хавтан" });
    else out.push({ id: id(), offset: x, width: rest, purpose: "cabinets" });
  };
  let cursor = 0;
  for (const p of fixed) {
    if (p.offset > cursor) fill(cursor, p.offset);
    out.push({ ...p, id: id() });
    cursor = Math.max(cursor, p.offset + p.width);
  }
  if (cursor < zone.length) fill(cursor, zone.length);
  return out;
}
